import React, { Component, Fragment } from 'react';
import ArticleCard from './ArticleCard';
import Loading from '../App/Loading'; 
import PropTypes from 'prop-types';
import { isValid, segmentTrackEvent } from '../../utils';
import { determineCardType } from '../../imgixUtils';
import { APP_ENV, SITE_HOST, AUTHOR_IMAGE_PLACEHOLDER, REACT_APP_DRUPAL_API_ENDPOINT } from '../../consts';

class VerticalRecirculation extends Component {
  constructor() {
	  super();
      this.state = {
        numArticles: 20, 
        seeMoreClicked: 0,
        articlesArray: [],
        showLoader: false,
      };
	    this.fetchMoreArticles = this.fetchMoreArticles.bind(this);
	    this.renderArticleCards = this.renderArticleCards.bind(this);
	    this.handleSeeMoreClick = this.handleSeeMoreClick.bind(this);
	}

	async fetchMoreArticles() {
    const { category, articles } = this.props;
    let { articlesArray } = this.state;
    const { numArticles, seeMoreClicked } = this.state;
    const completePath = `${REACT_APP_DRUPAL_API_ENDPOINT}/verticals/${category}?page=${seeMoreClicked + 2}`;
    try {
      const response = await fetch(completePath, {
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
      });

      const data = await response.json();
      if (data) {
        this.setState({ showLoader: false });
      }
      const newArticles = isValid(data.most_recent) ? data.most_recent : data.the_latest;
      articlesArray = !seeMoreClicked ? articles : articlesArray;
      const cleanArray = newArticles.filter(({ id }) => !articlesArray.some((e) => e.id === id));
      this.setState({
        articlesArray: [...articlesArray, ...cleanArray],
        numArticles: numArticles + 12,
        seeMoreClicked: seeMoreClicked + 1,
      });
    } catch (e) {
      console.log('fetch failed:', e);
    }
  }

  handleSeeMoreClick(scroll) {
    segmentTrackEvent('continue', { label: 'more', action: 'more' });
    this.setState({ showLoader: true });
    this.fetchMoreArticles();
  }

  organizeArticles(numArticles, articles) {

    let articlesWithCardClasses = articles.map((article, i) => {
      return {
        ...article,
        // bigCardOnly = true for PW redesign
        cardClass: determineCardType(i, false, true, true),
      };
    });

    return articlesWithCardClasses.slice(0, numArticles);
  }


  renderArticleCards(articleCards=[], shouldDisplayAds, shouldDisplaySponsored, showCategory) {
    const { isClient, isMobile, category, adUnit, showPubdate } = this.props;
    const landerCategory = category || 'homepage';
    let adInsertIdx = isMobile ? 6 : 12;
    let adCount = 0;
    let adInsertMultiple = isMobile ? 6 : 12;
    const articleCardsArray = isMobile && articleCards.length % 2 !== 0 ? articleCards.slice(0, -1) : articleCards;
    const renderedArticleCards = articleCardsArray.map((articleCard, i) => {
      if(typeof(articleCard.id) !== 'undefined') {
        const renderedArticleCard = <ArticleCard key={i} data={articleCard} isMobile={isMobile} shouldDisplaySponsored={shouldDisplaySponsored} showCategory={true} showPubdate={false} isClient={isClient}/>;
        
        if (!shouldDisplayAds) {
          return renderedArticleCard;
        }

        let nextIsAd = false;
        if (isMobile && adCount >= 1) {
          adInsertMultiple = 6; // was 6
        }

        if (i + 1 === adInsertIdx) {
          nextIsAd = true;
          adCount += 1;
          adInsertIdx += adInsertMultiple;
        }

        const includeAd = nextIsAd && shouldDisplayAds;
        const slotName = " htlad-purewow_lander_interstitial lander-interstital-ad";

        return (
          <Fragment>
            {renderedArticleCard}
            {includeAd &&
              <div className={slotName}
                data-unit={adUnit}
                data-targeting='{"slot_name":"purewow_lander_interstitial"}'></div>
            }
          </Fragment>
        );
      }
    });
    return renderedArticleCards;
  } 

  render() {
    const { articles, isMobile, isClient, showCategory = false, showPubdate = false } = this.props;
    let { numArticles } = this.state;
    const { seeMoreClicked, articlesArray, showLoader } = this.state;
    const shouldDisplayAds = isClient;
    const articleCards = seeMoreClicked ? this.organizeArticles(numArticles, articlesArray) : this.organizeArticles(numArticles, articles);
    const renderedArticleCards = this.renderArticleCards(articleCards, shouldDisplayAds, false, showCategory);
    const articleCardsClassName = 'article-cards col-12 col-4-sm';

    return (
      <div>
        <div className='vertical-section'>
          <h2 className='section-hed more-stories col-12 col-4-sm'>The Latest</h2>
          <div className={articleCardsClassName}>
            {renderedArticleCards}
          </div>
          <div className='see-more-button' onClick={this.handleSeeMoreClick}>See More</div>
          {showLoader && 
            <div className='loading'>
              <Loading />
            </div>
          }
        </div>
      </div>
    )
  }
}

export default VerticalRecirculation;
